import { isSelectable, TableIndexProps } from "./TableIndex";
import arrowTop from "../../assets/svg/arrowTop.svg";
import arrowBottom from "../../assets/svg/arrowbottom.svg";
import { styled } from "@mui/styles";
import FixedIcon from "./FixedIcon";
import { IconButton } from "@mui/material";
import CustomizeColumnIcon from "assets/icons/CustomizeColumnIcon";
import EditColumns from "./EditColumns";
import { useState } from "react";
import TableCheckbox from "./TableCheckbox";

export default function TableHeader(props: TableIndexProps) {
  const [anchorEl, setAnchorEl] = useState<HTMLElement>();

  return (
    <thead>
      <tr className="item-data-table" style={{ position: "relative" }}>
        {isSelectable(props.actions) && (
          <th className="checkbox">
            <TableCheckbox
              checked={props.tableItemsLength > 0 && props.tableItemsLength === props.selectedItemsLength}
              onChange={() => props.selectAllItems()}
            />
          </th>
        )}
        <th>#</th>
        {props.titles.map((title, key) => {
          return (
            <th className="item-title-th" key={key}>
              <div className="item-title">
                {!title.disableSearch && (
                  <div
                    className="arrow-top-div"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 3,
                    }}
                  >
                    <div
                      style={{
                        height: 12,
                        width: 16,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "flex-end",
                      }}
                      onClick={() => {
                        props.setSortQuery({
                          key: title.key,
                          dir: "ASC",
                          sortParams: title.filterParams,
                        });
                        // props.searchItems({
                        //     key: title.key,
                        //     dir: "ASC",
                        // }, {filterParams: title.filterParams});
                      }}
                    >
                      <img
                        src={arrowTop}
                        alt="arrowTop"
                        style={{
                          cursor: "pointer",
                          opacity:
                            props.sortQuery?.key === title.key && props.sortQuery?.dir === "ASC" ? 1 : 0.5,
                        }}
                      />
                    </div>
                    <div
                      className="d-flex"
                      style={{
                        height: 12,
                        width: 16,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "flex-start",
                      }}
                      onClick={() => {
                        props.setSortQuery({
                          key: title.key,
                          dir: "DESC",
                          sortParams: title.filterParams,
                        });
                        // props.searchItems({
                        //     key: title.key,
                        //     dir: "DESC",
                        // }, {filterParams: title.filterParams});
                      }}
                    >
                      <img
                        src={arrowBottom}
                        alt="arrowBottom"
                        style={{
                          cursor: "pointer",
                          opacity:
                            props.sortQuery?.key === title.key && props.sortQuery?.dir === "DESC" ? 1 : 0.5,
                        }}
                      />
                    </div>
                  </div>
                )}
                <div className="text-item">{title.name}</div>
              </div>
            </th>
          );
        })}
        <th className="fixed-column" style={{ width: "64px" }}>
          <CustomizeIcon>
            <IconButton onClick={(e) => setAnchorEl(e.currentTarget)}>
              <CustomizeColumnIcon />
            </IconButton>
            <EditColumns
              key={props.activeTab?.key}
              tabKey={props.activeTab?.key}
              titles={props.allTitles}
              selectedTitles={props.titles}
              handleClose={() => setAnchorEl(undefined)}
              anchorEl={anchorEl}
            />
          </CustomizeIcon>
        </th>
      </tr>
    </thead>
  );
}

const CustomizeIcon = styled(FixedIcon)({
  backgroundColor: "#F2F5FC",
  borderTop: "unset",
  display: "flex",
  justifyContent: "center",
});
